// ======================================================================
// File Name       : content
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import _ from 'lodash';
import {
  CONTENT_VIDEO_SEARCH,
  VIDEO_URL,
  VIDEO_EDIT,
  CONTENT_DRILL_LIST_SEARCH,
  CONTENT_DRILL_LIST_DOWNLOAD,
  CONTENT_DRILL_DETAIL,
  CONTENT_DELETE_DRILL,
  CONTENT_DRILL_SKIN_LIST,
  CONTENT_DRILL_EDIT,
  CONTENT_DRILL_SKIN_SEARCH_RESULT,
  CONTENT_DRILL_SKIN_INSERT,
  CONTENT_DRILL_SKIN_EDIT,
  CACHE_DRILL_SKIN_LIST,
  GET_QUESTION_LIST_DRILL_DETAIL,
} from '../constants/ActionTypes';
import * as ActionTypes from '../constants/actionTypes/content';
import * as ContentConstant from '../constants/ContentConstant';
import { RETURN_MAX_NUM, NUM_ATTRIBUTE_QUESTION_SEARCH, NUM_ATTRIBUTE_QUESTION_SEARCH_MAX } from '../constants/index';
import { calculateTotalAbsolutePoint, getQuestionList, getQuestionListArr } from '../utils/ContentUtils';

const initialState = {
  contents: {
    bySecernId: {},
    allSecernIds: [],
    recordNum: 0,
    startPosition: 0,
  },
  videoInfo: {
    recordNum: null,
    contentList: [],
  },
  videoUrl: {},
  videoEditRespond: {},
  drillListInfo: [],
  drillDetailInfo: {},
  skinListInfo: [],
  register: {
    drillType: 0,
    drillId: '',
    drillName: '',
    continuedFrStart: false,
    collectingLastMistakenIssue: false,
    collectingLastMistakenIssueEvenOnce: false,
    collectionQuestionsRegisteredInFavorites: false,
    restrictReanswer: false,
    reanswerTime: '',
    scoringMethod: 0,
    skinSetData: {
      skinSet: '',
      skinSetName: '',
      skinSetList: [],
    },
    questionId: '',
    oldQuestionId: '',
    showAddQuestionModal: false,
    advanceButtonText: 'plus',
    timeLimit: ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE,
    drillTimeLimit: '',
    acquisition: 0,
    countingMethod: 1, // step 6.3
    fullMark: 0,
    scoringRule: 0,
    useJudgment: false,
    partialPoint: '',
    useNote: false,
    useHTML: false,
    fileName: '',
    remark: '',
    showConfirmModal: false,
    registerSuccessfull: false,
    isAdvanceClosed: true,
    isAllowShowSearchMessage: false,
    adaptiveDrillDecisionQuestionNumber: 1,
    adaptiveDrillMaxQuestionNumber: '',
    attributeOptions: {},
    attributeText: {},
    isClosed: true,
    buttonText: 'plus',
    number: NUM_ATTRIBUTE_QUESTION_SEARCH,
  },
  drillImportedFileList: {},
  videoImportedFileList: {},
  resultOK: false,
  edit: {
    drillDetailInfo: null,
    contentDrillEdition: null,
    showDialog: false,
    editSuccessfull: false,
    newDrillIdTemplate: {
      show: true,
      subIndex: '',
      subQuestionSecernId: '',
    },
    skinSetList: [],
    questionDataList: [],
    drillKind: '',
    drillSecernId: '',
    drillTitle: '',
    continuedFrStart: false,
    collectingLastMistakenIssue: false,
    collectingLastMistakenIssueEvenOnce: false,
    collectionQuestionsRegisteredInFavorites: false,
    scoreForm: '',
    skinSetSecernId: '',
    questionId: '',
    oldQuestionId: '',
    showAddQuestionModal: false,
    advanceButtonText: 'plus',
    restrictReanswer: false,
    limitTimeAdaptedTarget: ContentConstant.CONTENT_DRILL_OBJECT.DO_NOT_USE,
    limitTimeOverAction: '',
    limitTimeCountForm: '',
    markRule: 0,
    sankakuJudgeUseSet: true,
    attentionRelateSet: false,
    attentionHtmlUse: false,
    attentionZipFile: '',
    attentionContent: '',
    learningMeaning: '',
    price: '',
    showConfirmModal: false,
    perfectPoint: 0,
    isAdvanceClosed: true,
    drillLimitTime: '',
    reanswerTime: '',
    isFirst: true,
    sankakuMarkSet: 0,
    isEdit: false,
    fileName: '',
    adaptiveDrillDecisionQuestionNumber: 1,
    adaptiveDrillMaxQuestionNumber: '',
  },
  questionAddDialog: {
    dialogQuestionInfo: {
      questionSecernId: '',
      questionTitle: '',
      questionKind: '',
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      ascendingDescendingSort: 0,
      questionSortType: '',
    },
    questionDataList: [],
    questionDataListTemp: [],
    selectedDrillGroupId: '',
  },
  notification: {
    search: {
      notifyMessageList: [],
      recordNum: 0,
    },
    isRegisterUpdateSuccessfully: false,
  },
  skinCaches: {
    institutionId: '',
    bySkinSetSecernId: {},
    allSkinSetSecernIds: [],
  },
  questionDrillList: {
    bySecernId: {},
    allSecernIds: [],
  },
  videoProgress: {
    showProgressBar: false,
    showReasonModal: false,
    showSuccessfulModal: false,
    percentage: 0,
    reason: '',
    isServerErr: false,
    handleCancelled: () => {},
  },
  isCancelUpload: false,
  questionDrillListArr: {
    bySecernId: {},
    allSecernIds: [],
  },
  questionAddDialogArr: {
    byDrillGroupId: {},
    byDrillGroupPoint: {},
    allDrillGroupIds: [],
    questionSelectMethod: {}, // STEP10.0.0
    questionCount:{},//STEP10.0.0
  },
  editingStructureSecernIdList: [],
};

export default function content(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.CONTENT_RECEIVE_LIST: {
      const { startPosition = 0, recordNum, contentList } = action;
      const contents = contentList.reduce(
        (acc, cur) => {
          const { contentSecernId, contentType } = cur;
          const contentSecernIdMix = `${contentSecernId}_${contentType}`;
          acc.bySecernId[contentSecernIdMix] = cur;
          acc.allSecernIds.push(contentSecernIdMix);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
          recordNum,
          startPosition,
        },
      );

      return {
        ...state,
        ...{ contents },
      };
    }
    case ActionTypes.CONTENT_INIT_EDITING: {
      const { secernId } = action;
      return {
        ...state,
        edittingContent:
        secernId && {}.hasOwnProperty.call(state.contents, secernId)
          ? { ...state.contents.bySecernId[secernId] }
          : {},
      };
    }
    case ActionTypes.CONTENT_RECEIVE_EDITING: {
      const { payload } = action;
      return {
        ...state,
        edittingContent: { ...state.edittingContent, ...payload },
      };
    }
    case CONTENT_VIDEO_SEARCH: {
      const { videoInfo } = action;
      return { ...state, ...{ videoInfo } };
    }
    case VIDEO_URL: {
      const { videoUrl } = action;
      return { ...state, ...{ videoUrl } };
    }
    case VIDEO_EDIT: {
      const { videoEditRespond } = action;
      return { ...state, ...{ videoEditRespond } };
    }
    case CONTENT_DRILL_LIST_SEARCH: {
      const { drillListSearchResult } = action;
      return { ...state, ...{ drillListInfo: drillListSearchResult } };
    }
    case CONTENT_DRILL_LIST_DOWNLOAD: {
      return state;
    }
    case CONTENT_DRILL_DETAIL: {
      const { drillDetailInfoResult } = action;
      const { questionAddDialog  } = state;
      const editquestionAddDialogArr = {
        byDrillGroupId: {},
        byDrillGroupPoint: {},
        allDrillGroupIds: [],
        questionSelectMethod: {}, // STEP10.0.0
        questionCount:{},//STEP10.0.0
      };
      if (drillDetailInfoResult) {
        const questionScopeListTemp = drillDetailInfoResult.drillGroupArray
        ? getQuestionList(drillDetailInfoResult.drillGroupArray)
        : [];
        questionAddDialog.questionDataList = questionScopeListTemp;
        const questionDataListTemp = resetQuestionDataListTemp(questionAddDialog.questionDataList);
        questionAddDialog.questionDataListTemp = questionDataListTemp;

        const questionScopeListAll = drillDetailInfoResult.drillGroupArray ? getQuestionListArr(drillDetailInfoResult.drillGroupArray) : [];
        if (questionScopeListAll) {
          questionScopeListAll.map((item) => {
            const drillGroupId = parseInt(item.drillGroupId, 10);
            const questionListTmp = item.questionListTmp;
            const groupPoint = parseInt(item.groupPoint, 10);
            const questionSelectMethod = parseInt(item.questionSelectMethod, 10);
            const questionCount = parseInt(item.questionCount, 10);
            if (editquestionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId) < 0) {
              editquestionAddDialogArr.allDrillGroupIds.push(drillGroupId);
            }
            if (editquestionAddDialogArr.byDrillGroupId) {
              editquestionAddDialogArr.byDrillGroupId[drillGroupId] = questionListTmp;
            }
            if (editquestionAddDialogArr.byDrillGroupPoint) {
              editquestionAddDialogArr.byDrillGroupPoint[drillGroupId] = groupPoint;
            }
            // STEP10.0.0 START
            if (editquestionAddDialogArr.questionSelectMethod) {
              editquestionAddDialogArr.questionSelectMethod[drillGroupId] = questionSelectMethod;
            }
            if (questionSelectMethod === ContentConstant.QUESTION_SELECT_METHOD.RANDOM && editquestionAddDialogArr.questionCount) {
              editquestionAddDialogArr.questionCount[drillGroupId] = questionCount;
            }
            // STEP10.0.0 END
          });
        }
      }

      return {
        ...state,
        ...{ drillDetailInfo: drillDetailInfoResult, drillDetailInfoOK: false },
        ...{ questionAddDialog },
        ...{ questionAddDialogArr: editquestionAddDialogArr },
      };
    }
    case CONTENT_DELETE_DRILL: {
      return state;
    }
    case CONTENT_DRILL_SKIN_LIST: {
      const { skinListResult } = action;
      const { skinList } = skinListResult;
      const drillDetailInfo = state.drillDetailInfo;
      if (skinList) {
        skinList.forEach((skinItem) => {
          if (skinItem.skinSetSecernId === drillDetailInfo.skinSetSecernId) {
            drillDetailInfo.skinSetName = skinItem.skinSetName;
          }
        });
      }
      return { ...state, ...{ drillDetailInfo } };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_ADD_QUESTION: {
      const { questionAddDialogArr } = state;
      const data = action.data;
      const drillGroupId = action.drillGroupId;
      // Update questionAddDialogArr
      if (questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId) < 0) {
        questionAddDialogArr.allDrillGroupIds.push(drillGroupId);
      }
      if (questionAddDialogArr.byDrillGroupId) {
        if (!questionAddDialogArr.byDrillGroupId[drillGroupId]) {
          questionAddDialogArr.byDrillGroupId[drillGroupId] = data;
        } else {
          const questionData = questionAddDialogArr.byDrillGroupId[drillGroupId];
          questionAddDialogArr.byDrillGroupId[drillGroupId] = _.union(questionData, data);
        }
      }

      return {
        ...state,
        ...{ questionAddDialogArr },
      };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_DELETE_QUESTION: {
      const { questionAddDialogArr } = state;
      const { drillGroupId, questionId } = action;
      if (questionAddDialogArr.byDrillGroupId[drillGroupId]) {
        const index = questionAddDialogArr.byDrillGroupId[drillGroupId].indexOf(questionId);
        if (index > -1) {
          questionAddDialogArr.byDrillGroupId[drillGroupId].splice(index, 1);
        }
      }
      return { ...state, questionAddDialogArr };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_ADD_FILE: {
      const { register } = state;
      register.fileName = action.fileName;
      register.file = action.file;
      return { ...state, ...{ register } };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_GET_SKIN_SET: {
      const { register } = state;
      if (action && action.data && action.data.skinList && action.data.skinList.length) {
        const skinList = action.data.skinList;
        register.skinSetData.skinSetList = skinList;
        let defaultSkinID = skinList[0].skinSetSecernId;
        let defaultSkinSetName = skinList[0].skinSetName;
        skinList.forEach((skinItem) => {
          if (skinItem.skinSetSecernId === '2') {
            defaultSkinID = skinItem.skinSetSecernId;
            defaultSkinSetName = skinItem.skinSetName;
          }
        });
        register.skinSetData.skinSet = defaultSkinID;
        register.skinSetData.skinSetName = defaultSkinSetName;
      }
      return { ...state, ...{ register } };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_DATA: {
      const { register } = state;
      register.registerSuccessfull = true;
      return { ...state, ...{ register } };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_UPDATE_QUESTION_DIALOG_SEARCH_INFO: {
      const { questionAddDialog } = state;
      questionAddDialog.dialogQuestionInfo = action.searchInfo;
      return { ...state, ...{ questionAddDialog } };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_RESET_QUESTION_DIALOG_SEARCH_INFO: {
      const { questionAddDialog } = state;
      questionAddDialog.dialogQuestionInfo = {
        questionSecernId: '',
        questionTitle: '',
        questionKind: '',
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
        ascendingDescendingSort: 0,
        questionSortType: '',
      };
      const questionDataListTemp = resetQuestionDataListTemp(questionAddDialog.questionDataList);
      questionAddDialog.questionDataListTemp = questionDataListTemp;
      return { ...state, ...{ questionAddDialog } };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_RESET_QUESTION_DIALOG: {
      const questionAddDialog = { ...state.questionAddDialog };
      questionAddDialog.dialogQuestionInfo = {
        questionSecernId: '',
        questionTitle: '',
        questionKind: '',
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
        ascendingDescendingSort: 0,
        questionSortType: '',
      };
      questionAddDialog.questionDataList = [];
      questionAddDialog.questionDataListTemp = [];
      const initQuestionAddDialogArr = {
        allDrillGroupIds: [],
        byDrillGroupId: {},
        byDrillGroupPoint: {},
        questionSelectMethod: {}, // STEP10.0.0
        questionCount:{},//STEP10.0.0
      };
      return {
        ...state,
        ...{ questionAddDialog },
        ...{ questionAddDialogArr: initQuestionAddDialogArr },
      };
    }
    case ActionTypes.CONTENT_DRILL_REGISTER_RESET_DATA: {
      const register = action.data;
      const initQuestionAddDialogArr = {
        allDrillGroupIds: [],
        byDrillGroupId: {},
        byDrillGroupPoint: {},
        questionSelectMethod: {}, // STEP10.0.0
        questionCount:{},//STEP10.0.0
      };
      return {
        ...state,
        ...{ register },
        ...{ questionAddDialogArr: initQuestionAddDialogArr },
      };
    }
    case ActionTypes.CONTENT_DRILL_EDIT_RESET_DATA: {
      const { edit } = initialState;
      const initQuestionAddDialogArr = {
        allDrillGroupIds: [],
        byDrillGroupId: {},
        byDrillGroupPoint: {},
        questionSelectMethod: {}, // STEP10.0.0
        questionCount:{},//STEP10.0.0
      };
      return {
        ...state,
        edit,
        ...{ questionAddDialogArr: initQuestionAddDialogArr },
      };
    }
    case ActionTypes.IMPORT_DRILL_LIST: {
      return {
        ...state,
        ...{ resultOK: true },
      };
    }
    case ActionTypes.IMPORT_VIDEO_LIST: {
      return {
        ...state,
        ...{ resultOK: true },
      };
    }
    case ActionTypes.RECEIVED_IMPORTED_FILE_LIST: {
      const { recordNum, importResultList } = action;
      const drillImportedFileList = { recordNum, importResultList };
      return {
        ...state,
        ...{ drillImportedFileList },
      };
    }
    case ActionTypes.RECEIVED_VIDEO_FILE_LIST: {
      const { recordNum, importResultList } = action;
      const videoImportedFileList = { recordNum, importResultList };
      return {
        ...state,
        ...{ videoImportedFileList },
      };
    }
    case CONTENT_DRILL_SKIN_SEARCH_RESULT: {
      const { skinListResult } = action;
      return { ...state, ...{ skinListResult } };
    }
    case CONTENT_DRILL_SKIN_INSERT: {
      const { skinSetSecernId } = action;
      return { ...state, ...{ skinSetSecernId } };
    }
    case CONTENT_DRILL_SKIN_EDIT: {
      const { skinSetSecernId } = action;
      return { ...state, ...{ skinSetSecernId } };
    }
    case CONTENT_DRILL_EDIT: {
      const { drillDetailInfoResult } = action;
      return { ...state, ...{ drillDetailInfoOK: true } };
    }
    case ActionTypes.CONTENT_DRILL_EDIT_GET_SKIN_SET: {
      const { edit } = state;
      edit.skinSetList = action.data.skinList;
      return { ...state, ...{ edit } };
    }
    case ActionTypes.CONTENT_NOTIFICATION_SEARCH: {
      const { notification } = state;
      notification.search.notifyMessageList = action.data.notifyMessageSetList;
      notification.search.recordNum = action.data.recordNum;
      return { ...state, ...{ notification } };
    }
    case ActionTypes.CONTENT_NOTIFICATION_REGISTER: {
      const { notification } = state;
      notification.isRegisterUpdateSuccessfully = true;
      return { ...state, ...{ notification } };
    }
    case ActionTypes.CONTENT_NOTIFICATION_UPDATE: {
      const { notification } = state;
      notification.isRegisterUpdateSuccessfully = true;
      return { ...state, ...{ notification } };
    }
    case ActionTypes.CONTENT_NOTIFICATION_REGISTER_RESET: {
      const { notification } = state;
      notification.isRegisterUpdateSuccessfully = false;
      return { ...state, ...{ notification } };
    }
    case ActionTypes.CONTENT_NOTIFICATION_DELETE: {
      const { notification } = state;
      notification.isRegisterUpdateSuccessfully = true;
      return { ...state, ...{ notification } };
    }
    case ActionTypes.CONTENT_LINK_LIST: {
      const { contentLinkInfo } = action;
      if (contentLinkInfo.recordNum > 0) {
      }
      return { ...state, ...{ contentLinkInfo } };
    }
    case ActionTypes.CONTENT_LINK_EDIT: {
      return { ...state, ...{ redirectToList: true } };
    }
    case CACHE_DRILL_SKIN_LIST: {
      const { skinList, institutionId } = action;
      const skinCaches = skinList.reduce((acc, cur) => {
        if (cur && cur.skinSetSecernId) {
          const skinSetSecernId = cur.skinSetSecernId;
          if (acc.allSkinSetSecernIds.indexOf(skinSetSecernId) < 0) {
            acc.allSkinSetSecernIds.push(skinSetSecernId);
          }
          if (!acc.bySkinSetSecernId[skinSetSecernId]) {
            acc.bySkinSetSecernId[skinSetSecernId] = cur;
          }
        }
        return acc;
      }, {
        institutionId,
        bySkinSetSecernId: {},
        allSkinSetSecernIds: [],
      });
      return {
        ...state,
        skinCaches,
      };
    }
    case ActionTypes.CREATE_VALUE_ATTRIBUTE_ITEM_DRILL: {
      const attributeOptions = {};
      const attributeText = {};
      const register = { ...state.register };
      for (let i = 1; i <= NUM_ATTRIBUTE_QUESTION_SEARCH_MAX; i++) {
        register.attributeOptions[`attribute${i}`] = '';
        register.attributeText[`attribute${i}`] = '';
      }
      return {
        ...state,
        register,
      };
    }
    case GET_QUESTION_LIST_DRILL_DETAIL: {
      const { questionDrillListArr } = state;
      const { data } = action;
      let questionDrillList = {
        bySecernId: {},
        allSecernIds: [],
      };
      if (data && data.questionList) {
        questionDrillList = data.questionList.reduce((acc, cur) => {
          if (cur && cur.questionSecernId) {
            const questionSecernId = cur.questionSecernId;
            // acc.bySecernId[questionSecernId] = cur;
            acc.bySecernId[questionSecernId] = {};
            acc.bySecernId[questionSecernId].questionSecernId = cur.questionSecernId;
            acc.bySecernId[questionSecernId].questionTitle = cur.questionTitle;
            acc.allSecernIds.push(questionSecernId);
            if (questionDrillListArr.allSecernIds.indexOf(questionSecernId) < 0) {
              questionDrillListArr.allSecernIds.push(questionSecernId);
            }
            if (!questionDrillListArr.bySecernId[questionSecernId]) {
              // #7245 START
              if (cur.subQuestionArray) { // in case of big question
                cur.absolutePoint = calculateTotalAbsolutePoint(cur.subQuestionArray);
              }
              // #7245 END
              questionDrillListArr.bySecernId[questionSecernId] = cur;
            }
            return acc;
          }
        }, {
          bySecernId: {},
          allSecernIds: [],
        });
      }
      return {
        ...state,
        questionDrillList,
        questionDrillListArr,
      };
    }
    case ActionTypes.REMOVE_QUESTION_LIST_DRILL: {
      const questionDrillList = {
        bySecernId: {},
        allSecernIds: [],
      };
      const questionDrillListArr = {
        bySecernId: {},
        allSecernIds: [],
      };
      return {
        ...state,
        questionDrillList,
        questionDrillListArr,
      };
    }
    case ActionTypes.REMOVE_ALL_QUESTION_FROM_LIST: {
      const { questionAddDialogArr } = state;
      const { drillGroupId } = action;
      const questionData = questionAddDialogArr.byDrillGroupId[drillGroupId];
      if (questionData) {
        delete questionAddDialogArr.byDrillGroupId[drillGroupId];
      }
      return {
        ...state,
        questionAddDialogArr,
      };
    }

    case ActionTypes.REMOVE_GROUP: {
      const { questionAddDialogArr } = state;
      const { drillGroupId } = action;
      const index = questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId);
      if (index > -1) {
        questionAddDialogArr.allDrillGroupIds.splice(index, 1);
      }
      const questionData = questionAddDialogArr.byDrillGroupId[drillGroupId];
      if (questionData) {
        delete questionAddDialogArr.byDrillGroupId[drillGroupId];
      }
      const groupPoint = questionAddDialogArr.byDrillGroupPoint[drillGroupId];
      if (groupPoint) {
        delete questionAddDialogArr.byDrillGroupPoint[drillGroupId];
      }
      // STEP10.0.0 START
      const questionSelectMethod = questionAddDialogArr.questionSelectMethod[drillGroupId];
      if (questionSelectMethod) {
        delete questionAddDialogArr.questionSelectMethod[drillGroupId];
      }
      const questionCount = questionAddDialogArr.questionCount[drillGroupId];
      if (questionCount) {
        delete questionAddDialogArr.questionCount[drillGroupId];
      }
      // STEP10.0.0 END

      const updatedquestionAddDialogArr = {
        byDrillGroupId: {},
        byDrillGroupPoint: {},
        allDrillGroupIds: [],
        questionSelectMethod: {}, // STEP10.0.0
        questionCount:{},//STEP10.0.0
      };
      questionAddDialogArr.allDrillGroupIds.forEach((drillId, idx) => {
        updatedquestionAddDialogArr.allDrillGroupIds.push(drillId);
        updatedquestionAddDialogArr.byDrillGroupId[drillId] = questionAddDialogArr.byDrillGroupId[drillId];
        updatedquestionAddDialogArr.byDrillGroupPoint[drillId] = questionAddDialogArr.byDrillGroupPoint[drillId];
        // STEP10.0.0 START
        updatedquestionAddDialogArr.questionSelectMethod[drillId] = questionAddDialogArr.questionSelectMethod[drillId];
        updatedquestionAddDialogArr.questionCount[drillId] = questionAddDialogArr.questionCount[drillId];
        // STEP10.0.0 END
      });

      return {
        ...state,
        questionAddDialogArr: updatedquestionAddDialogArr,
      };
    }

    case ActionTypes.ADD_GROUP: {
      const { questionAddDialogArr } = state;
      const { drillGroupId } = action;
      const index = questionAddDialogArr.allDrillGroupIds && questionAddDialogArr.allDrillGroupIds.indexOf(drillGroupId);
      if (index < 0) {
        questionAddDialogArr.allDrillGroupIds.push(drillGroupId);
      }

      return {
        ...state,
        ...{ questionAddDialogArr },
      };
    }

    case ActionTypes.UPDATE_VIDEO_PROGRESS: {
      const { data } = action;
      return {
        ...state,
        videoProgress: { ...data },
      };
    }
    case ActionTypes.CANCEL_UPLOAD: {
      const { data } = action;
      const reason = '';
      return {
        ...state,
        isCancelUpload: data,
        videoProgress: { ...state.videoProgress, reason },
      };
    }
    // STEP9.0.0 START
    case ActionTypes.CONTENT_DRILL_QUESTION_FOR_SORT:
      return getDrillQuestionListForSort(state, action);

    case ActionTypes.CONTENT_UPDATE_DISPLAY_ORDER_STRUCTURE_LIST:
      return updateDisplayOrderStructureList(state, action);

    case ActionTypes.CONTENT_SAVE_DISPLAY_ORDER_DRILL_QUESTION:
        return saveDisplayOrderDrillQuestion(state, action);
    // STEP9.0.0 END
    default:
      return {
        ...state,
        ...{
          drillImportedFileList: {},
          videoImportedFileList: {},
          resultOK: false,
          editSuccessfull: false,
          drillDetailInfoOK: false,
          edit: {
            isEdit: false,
          },
        },
      };
  }
}

function resetQuestionDataListTemp(questionDataList) {
  const questionDataListTemp = [];
  questionDataList && questionDataList.forEach((questionId) => {
    questionDataListTemp.push(questionId);
  }, this);
  return questionDataListTemp;
}

// STEP9.0.0 START
function getDrillQuestionListForSort(state, action) {
  const { groupIndex, drillGroupId } = action;
  const { byDrillGroupId } = state.questionAddDialogArr;
  return {
    ...state,
    editingGroupIndex: groupIndex,
    editingDrillGroupId: drillGroupId,
    editingStructureSecernIdList: byDrillGroupId[drillGroupId],
  };
}

function updateDisplayOrderStructureList(state, action) {
  const { structureSecernIdList } = action;
  return {
    ...state,
    editingStructureSecernIdList: structureSecernIdList,
  };
}

export function saveDisplayOrderDrillQuestion(state, action) {
  const { editingDrillGroupId, editingStructureSecernIdList } = state;
  const { byDrillGroupId } = state.questionAddDialogArr;
 byDrillGroupId[editingDrillGroupId] = editingStructureSecernIdList;
  return {
    ...state,
  };
}
// STEP9.0.0 END